import React, { useState, useEffect } from 'react';
import axios from 'axios';
import { useParams, Link, useNavigate } from 'react-router-dom';
import { Container, Card, Breadcrumb, Spinner, Button, Alert } from 'react-bootstrap';

const DocumentSummary = () => {
    const { id } = useParams();
    const navigate = useNavigate();
    const [document, setDocument] = useState(null);
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState(null);
    const [deleteMessage, setDeleteMessage] = useState(null);

    useEffect(() => {
        const fetchDocument = async () => {
            try {
                // Fetch document details to get the summary
                const res = await axios.get(`${process.env.REACT_APP_API_URL}/api/documents/single/${id}`);
                setDocument(res.data);
            } catch (err) {
                console.error('Error fetching document summary:', err);
                setError('Impossible de charger le résumé du document.');
            } finally {
                setLoading(false);
            }
        };

        fetchDocument();
    }, [id]);

    const handleDeleteSummary = async () => {
        if (window.confirm('Êtes-vous sûr de vouloir supprimer ce résumé ?')) {
            try {
                await axios.delete(`${process.env.REACT_APP_API_URL}/api/documents/${id}/summary`);
                setDeleteMessage({ type: 'success', text: 'Résumé supprimé avec succès.' });
                // Optionally, navigate back to module details or update state
                navigate(`/modules/${document.module_id}`);
            } catch (err) {
                console.error('Error deleting summary:', err);
                setDeleteMessage({ type: 'danger', text: 'Erreur lors de la suppression du résumé.' });
            }
        }
    };

    if (loading) {
        return (
            <Container className="mt-4 text-center">
                <Spinner animation="border" role="status">
                    <span className="visually-hidden">Chargement du résumé...</span>
                </Spinner>
                <p>Chargement du résumé...</p>
            </Container>
        );
    }

    if (error) {
        return <Container className="mt-4"><p className="text-danger">{error}</p></Container>;
    }

    if (!document || !document.summary) {
        return <Container className="mt-4"><p>Aucun résumé disponible pour ce document.</p></Container>;
    }

    // Split the summary by newlines and render each part as a paragraph
    const formattedSummary = document.summary.split(/\r?\n/).map((paragraph, index) => (
        <p key={index}>{paragraph}</p>
    ));

    return (
        <Container className="mt-4">
            <Breadcrumb>
                <Breadcrumb.Item linkAs={Link} linkProps={{ to: "/" }}>Modules</Breadcrumb.Item>
                <Breadcrumb.Item linkAs={Link} linkProps={{ to: `/modules/${document.module_id}` }}>{document.module_name}</Breadcrumb.Item>
                <Breadcrumb.Item active>Résumé de {document.nom}</Breadcrumb.Item>
            </Breadcrumb>

            {deleteMessage && <Alert variant={deleteMessage.type}>{deleteMessage.text}</Alert>}

            <Card>
                <Card.Header className="d-flex justify-content-between align-items-center">
                    <h2>Résumé de: {document.nom}</h2>
                    <Button variant="danger" onClick={handleDeleteSummary}>Supprimer Résumé</Button>
                </Card.Header>
                <Card.Body>
                    {formattedSummary}
                </Card.Body>
            </Card>
        </Container>
    );
};

export default DocumentSummary;